<template>
<div>

  <el-dialog
    :title="`质控问题登记`"
    :visible.sync="show" 
    width="65%"
    append-to-body
    @close="cancel"
  >
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane :label="`器械清洗不合格`" :disabled="node === 1 || status === 1" name="clean"></el-tab-pane>
      <el-tab-pane :label="`器械完整性不合格`" :disabled="status === 1" name="intact"></el-tab-pane>
    </el-tabs>
    <el-form ref="queryForm" :model="queryForm" label-position="right" label-width="180px">
      <el-row>
        <el-col :span="8">
          <el-form-item
            prop="check_type"
            :label="`检查类型`"
            :rules="[
              {required: true, message: `请选择`, trigger: 'change'}
            ]"
          >
            <el-select v-model="queryForm.check_type" clearable :placeholder="`请选择`" :disabled="status == 1" @change="checkTypeChange(queryForm.check_type)">
              <el-option
                v-for="item in examineList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <!-- 补登记的时候发生时间事可选的 -->
        <el-col :span="8" v-if="status==3">
          <el-form-item
            :label="`发生时间`"
            prop="happen_time"
            :rules="[
              {required: true, message: `请选择`, trigger: 'blur'}
            ]"
          >
            <el-date-picker
              v-model="queryForm.happen_time"
              type="datetime"
              value-format="yyyy-MM-dd HH:mm:ss"
              :placeholder="`请选择`"
              >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-else>
          <el-form-item
            :label="`发生时间`"
          >
            <p>{{ queryForm.happen_time }}</p>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="status===3">
          <el-form-item :label="`包码`">
          <el-input
            :placeholder="`请输入包码并回车`"
            v-model="queryForm.code"
            clearable
            @keydown.enter.native="onEnter"
            >
          </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            prop="table_id"
            :label="`器械包名称`"
          >
            <el-select v-if="status === 0" v-model="queryForm.table_id" :placeholder="`请选择`" :disabled="status == 1" @change="getInstrumentNameChange(queryForm.table_id)">
              <el-option
                v-for="item in instrumentsetList"
                :key="item.table_id"
                :label="item.name_index"
                :value="item.table_id">
              </el-option>
            </el-select>
            <p v-else>
              {{ queryForm.instrumentset_name }}
            </p>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="queryForm.code&&status!==3">
          <el-form-item
            :label="`包码`"
          >
            <p>{{ queryForm.code }}</p>
          </el-form-item>
        </el-col>
      </el-row>
      <el-table
        class="mb10"
        :data="list"
        border
        :default-expand-all="activeName === 'clean'? true : false"
      >
        <el-table-column type="expand" v-if="activeName === 'clean'" key="1001">
          <template  slot-scope="scope" >
            <el-table
              class="mb10"
              :data="scope.row.parts"
              :header-cell-style="{background: '#FFCC33'}"
              border
              v-if="activeName === 'clean'"
            >
              <el-table-column
              :label="`部位`"
              >
                <template slot-scope="childProp">
                  <el-select v-model="childProp.row.instrument_part_type_id" :placeholder="`请选择`" :disabled="status == 1" @change="partsChange(childProp.row, scope.row)">
                    <el-option
                      v-for="item in scope.row.partList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                      :disabled="item.disabled">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
              :label="`监测方式`"
              >
                <template slot-scope="childProp">
                  <el-select v-model="childProp.row.monitor_type" :placeholder="`请选择`" :disabled="status == 1" @change="monitorTypeChange(childProp.row)">
                    <el-option
                      v-for="item in monitorTypeList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column
              :label="`不合格类型`"
              >
                <template slot-scope="childProp">
                  <el-select v-model="childProp.row.unqualified_type" :placeholder="`请选择`" :disabled="status == 1" @change="unqualifiedTypeChange(childProp.row,scope.$index,childProp.$index)">
                    <el-option
                      v-for="item in unqualifiedTypeList"
                      :key="item.value"
                      :label="item.name"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column :label="`不合格原因`">
                <template slot-scope="childProp">
                  <el-input v-model="childProp.row.unqualified_type_remark" :placeholder="`请输入`" :disabled="childProp.row.unqualified_type != 5 || status == 1" />
                </template>
              </el-table-column>
              <el-table-column
              :label="`操作`"
              >
                <template slot-scope="childScope">
                  <el-button type="primary" size="mini" :disabled="status === 1" icon="el-icon-circle-plus-outline" @click.stop="childAdd(scope.row.parts)"></el-button>
                  <el-button type="danger" size="mini" :disabled="status === 1" icon="el-icon-remove-outline" @click.stop="childDelete(childScope.$index, scope.row.parts)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
        </el-table-column>
        <el-table-column
          :label="`器械名称`"
          key="1002"
        >
          <template slot-scope="scope">
            <el-select v-model="scope.row.instrument_index" :placeholder="`请选择`" :disabled="status == 1" @change="instrumentTableChange(scope.row)">
              <el-option
                v-for="item in instrumentList"
                :key="item.instrument_index"
                :label="item.name_index"
                :value="item.instrument_index"
                :disabled="item.disabled">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          :label="`器械类型`"
          key="1003"
        >
          <template slot-scope="scope">
            <p>{{ scope.row.instrument_part_type_text }}</p>
          </template>
        </el-table-column>
        <el-table-column
          :label="`处理方式`"
          key="1004"
        >
          <template slot-scope="scope">
            <el-select v-model="scope.row.handle_type" :placeholder="`请选择`" :disabled="status == 1" @change="handleTypeChange(scope.row)">
              <el-option
                v-for="item in handleTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
            <el-input class="mt5" v-if="scope.row.handle_type === 4" v-model="scope.row.else_remark" :disabled="status == 1"></el-input>
          </template>
        </el-table-column>
        <el-table-column
          v-if="activeName === 'intact'"
          :label="`不合格类型`"
          key="1005"
        >
          <template slot-scope="scope">
            <el-select v-model="scope.row.unqualified_type" :placeholder="`请选择`" :disabled="status == 1" @change="unqualifiedTypeChange(scope.row)">
              <el-option
                v-for="item in unqualifiedTypeList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
          :label="`备注`"
          key="1006"
        >
          <template slot-scope="scope">
            <el-input
              type="textarea"
              :disabled="status == 1"
              :rows="2"
              :placeholder="`请输入`"
              v-model="scope.row.remark">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column
          :label="`照片`"
          key="1008"
        >
          <template slot-scope="scope">
            <span
              v-for="(image, index) in scope.row.files"
              :key="index"
              class="list-pic"
            >
              <el-image
                :src="image.url"
                :preview-src-list="scope.row.files.map((i) => i.url)"
              ></el-image>
              <i
                class="el-icon-error del"
                @click="delImg(scope.row, index)"
              ></i>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          :label="`操作`"
          key="1007"
        >
          <template slot-scope="scope">
            <el-button class="mt5" type="primary" size="mini" icon="el-icon-circle-plus-outline" :disabled="status === 1" @click.stop="parentAdd()"></el-button>
            <el-button class="mt5" type="danger" size="mini" icon="el-icon-remove-outline" :disabled="status === 1" @click.stop="parentDelete(scope.$index)"></el-button>
            <el-button class="mt5" type="info" size="mini" v-if="status!=1" @click="takePicture(scope.row)">拍照</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row v-if="activeName === 'intact'">
        <el-col :span="8">
          <el-form-item
            :label="`检验人`"
            prop="checkout_uid"
            :rules="[
              {required: true, message: `请选择`, trigger: 'change'}
            ]"
          >
            <el-select v-model="queryForm.checkout_uid" clearable :placeholder="`请选择`" :disabled="status == 1">
              <el-option
                v-for="item in registerUserList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="activeName === 'clean'">
        <el-col :span="8">
          <el-form-item
            :label="`清洗人`"
          >
            <p>{{ queryForm.clean_user }}</p>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="exec[359]">
          <el-form-item
            :label="`初检人`"
            prop="first_check_uid"
            :rules="[
              {required: true, message: `请选择`, trigger: 'change'}
            ]"
          >
            <el-select v-model="queryForm.first_check_uid" clearable :placeholder="`请选择`" :disabled="status == 1">
              <el-option
                v-for="item in registerUserList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="`复检人`"
            prop="recheck_uid"
          >
            <p v-if="!exec[459]">{{ queryForm.recheck_user }}</p>
            <el-select v-else v-model="queryForm.recheck_uid" filterable clearable remote :remote-method="remoteRecheckMethod" @focus="remoteRecheckMethod()" :placeholder="`请选择`" :disabled="status == 1">
              <el-option
                v-for="item in recheckList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="exec[359] && activeName === 'clean'">
        <el-col :span="8">
          <el-form-item
            :label="`排班`"
            prop="scheduling"
          >
            <el-select v-model="queryForm.scheduling" clearable :placeholder="`请选择`" :disabled="status == 1" @change="schedulingChange(queryForm.scheduling)">
              <el-option
                v-for="item in schedulingList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="`工作时间`"
            prop="work_time"
          >
            <el-select v-model="queryForm.work_time" clearable :placeholder="`请选择`" :disabled="status == 1" @change="workTimeChange(queryForm.work_time)">
              <el-option
                v-for="item in workTimeList"
                :key="item.value"
                :label="item.name"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item
            :label="`登记人`"
            prop="register_uid"
            :rules="[
              {required: true, message: `请选择`, trigger: 'change'}
            ]"
          >
            <el-select v-model="queryForm.register_uid" clearable :placeholder="`请选择`" :disabled="status == 1" >
              <el-option
                v-for="item in registerUserList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="exec[359] && activeName === 'clean'">
          <el-form-item
            :label="`组长抽查`"
            prop="group_leader_uid"
          >
            <el-select v-model="queryForm.group_leader_uid" clearable :placeholder="`请选择`" :disabled="status == 1" >
              <el-option
                v-for="item in registerUserList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="exec[359] && activeName === 'clean'">
          <el-form-item
            :label="`护士抽查`"
            prop="nurse_uid"
          >
            <el-select v-model="queryForm.nurse_uid" clearable :placeholder="`请选择`" :disabled="status == 1" >
              <el-option
                v-for="item in registerUserList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" v-if="exec[359] && activeName === 'clean'">
          <el-form-item
            :label="`质控人`"
            prop="quality_uid"
          >
            <el-select v-model="queryForm.quality_uid" clearable :placeholder="`请选择`" :disabled="status == 1" >
              <el-option
                v-for="item in registerUserList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="`预处理人`"
            prop="pre_handle_uid"
          >
            <el-select v-model="queryForm.pre_handle_uid" clearable :placeholder="`请选择`" filterable remote reserve-keyword :remote-method="preHandleUidMethod" :disabled="status == 1">
              <el-option
                v-for="item in preHandleUidList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item
          :label="`质检方`"
          prop="quality_part"
          :rules="[
            {required: true, message: `请选择`, trigger: 'change'}
          ]"
        >
          <el-select v-model="queryForm.quality_part" clearable :placeholder="`请选择`" :disabled="status == 1" @change="qualityPartChange(queryForm.quality_part)">
            <el-option
              v-for="item in qualityPartList"
              :key="item.value"
              :label="item.name"
              :value="item.value">
            </el-option>
          </el-select>
          <el-select v-if="queryForm.quality_part === 1" class="ml5" v-model="queryForm.quality_part_department_id" clearable :placeholder="`请选择`" :disabled="status == 1" filterable remote :remote-method="getDepartment" @focus="getDepartment('')">
            <el-option
              v-for="item in dempartmentOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-row>
      <el-row class="d-flex center">
        <el-button size="mini" @click="cancel">取消</el-button>
        <el-button size="mini" v-if="status == 0||status==3" type="primary" @click="submit">确定</el-button>
      </el-row>
    </el-form>
  </el-dialog>
  <PictureSelect ref="pictureSelect" @complete="onFinishShot" />
  </div>
</template>


<script>
import { mapGetters } from 'vuex'
import { userOptions, qualityIssuesDetail, qualityIssuesRegister, scanCheckUser, departmentOptions } from '@/api.js'
import PictureSelect from '@/components/common/PictureSelect/index.vue'

export default {
  name: 'cleanUnstanard',
  components:{
    PictureSelect
  },
  data () {
    return {
      activeRow:null,
      show: false,
      activeName: 'clean',
      queryForm: {
        check_type: undefined,
        check_type_text: undefined,
        first_check_uid: undefined,
        scheduling: undefined,
        work_time: undefined,
        register_uid: undefined,
        group_leader_uid: undefined,
        nurse_uid: undefined,
        quality_uid: undefined,
        quality_part: undefined,
        checkout_uid: undefined,
        recheck_uid: undefined,
        happen_time: undefined,
        quality_part_department_id: undefined
      },
      status: 0,
      node: 0, // 节点
      list: [],
      row: {},
      examineList: [],
      instrumentsetList: [],
      schedulingList: [],
      workTimeList: [],
      registerUserList: [],
      qualityPartList: [],
      monitorTypeList: [],
      unqualifiedTypeList: [],
      instrumentList: [],
      handleTypeList: [],
      cleanUnQualified: [], // 清洗不合格类型
      cleanHandleType: [], // 清洗处理方式
      intactUnQualified: [], // 器械完整不合格类型
      intactHandleType: [], // 器械完整处理方式
      recheckList: [],
      dempartmentOptions: [], // 科室
      preHandleUidList: [], // 预处理人
    }
  },
  computed: {
    ...mapGetters(['exec', 'user', 'system'])
  },
  methods: {
    async open(row, type, status, node) { 
      // 弹窗打开放到获取详情后，如果获取详情有器械才打开
      this.activeName = type
      this.status = status
      this.node = node
      this.row = row
      status!==3&&this.handleInstrumentsetArr()  //补登记的时候不做处理
      await this.getDict()
      if(status!==3){this.getDetails()}else{
        this.show=true
      }  //补登记的时候直接打开
      this.getUserList()
      this.remoteRecheckMethod()
      if (type === 'intact') {
        this.unqualifiedTypeList = this.intactUnQualified
        this.handleTypeList = this.intactHandleType
      } else {
        this.unqualifiedTypeList = this.cleanUnQualified
        this.handleTypeList = this.cleanHandleType
      }
      this.getDepartment('')
      this.preHandleUidMethod('')
    },
    // 处理器械包名称数组 且赋值数组一个的值
    handleInstrumentsetArr() {
      const arr = []
      for(let i = 0; i < this.row.number; i++) {
        const name = this.row.instrumentset_name + '-' + (i+1)
        const table_id = this.row.table_id[i]
        let query = {
          name_index: name,
          table_id: table_id,
          name: this.row.instrumentset_name,
          instrumentset_id: this.row.instrumentset_id,
        }
        arr.push(query)
      }
      if (this.status === 0) {
        this.queryForm.happen_time = this.$moment(this.system.time).format('yyyy-MM-DD HH:mm:ss')
        this.queryForm.code = this.row.code
      }
      this.instrumentsetList = arr
      this.queryForm.instrumentset_index = this.instrumentsetList[0].instrumentset_index
      this.queryForm.instrumentset_id = this.instrumentsetList[0].instrumentset_id
      this.queryForm.table_id = this.instrumentsetList[0].table_id
      this.queryForm.instrumentset_name = this.instrumentsetList[0].name
    },
    // 通过详情接口获取器械数据
    getDetails() {
      const query = {
        type: 7,
        register_type: this.activeName === 'clean' ? 0 : 1,
        node: this.node,
        table_id: this.queryForm.table_id,
        instrumentset_id: this.queryForm.instrumentset_id,
      }
      if(this.status==3){
        query.code = this.queryForm.code
      }

      this.$request('get', qualityIssuesDetail, query)
      .then((res) => {
        if (res.instrument_part.length === 0) {
          this.$message.error(`该包没有器械无法登记`)
          this.cancel()
          return
        } else {
          this.show = true
        }
        if(!res.basic.instrumentset_name || !res.basic.instrumentset_id){  //如果详情中没有器械包名称，以带过来的为准
          delete res.basic.instrumentset_name 
          delete res.basic.instrumentset_id
        }
        if(this.status!==3){
          delete res.basic.table_id    //只有补登记的时候才会用这个table_id
        }
        res.basic.quality_part_department_id = res.basic.quality_part_department_id? res.basic.quality_part_department_id : ''
        this.queryForm = Object.assign(this.queryForm, res.basic)
        // 处理不必填字段为空时后端返回0，处理为空
        if (this.queryForm.recheck_uid === 0) {
          this.queryForm.recheck_uid = ''
        }
        if (this.queryForm.scheduling === 0) {
          this.queryForm.scheduling = ''
        }
        if (this.queryForm.work_time === 0) {
          this.queryForm.work_time = ''
        }
        if (this.queryForm.group_leader_uid === 0) {
          this.queryForm.group_leader_uid = ''
        }
        if (this.queryForm.nurse_uid === 0) {
          this.queryForm.nurse_uid = ''
        }
        if (this.queryForm.quality_uid === 0) {
          this.queryForm.quality_uid = ''
        }
        
        const instList = []
        res.instrument_part.forEach((item) => {
          item.parts.unshift({id: 0, name: `整体`, disabled: false})
          for(let i=0; i<item.number; i++) {
            const id_index = item.id + '-' + (i+1)
            const name_index = item.name + '-' + (i+1)
            const query = {
              abc_code: item.abc_code,
              id: item.id,
              instrument_part_type_id: item.instrument_part_type_id,
              instrument_part_type_text: item.instrument_part_type_text,
              instrument_index: id_index,
              name: item.name,
              name_index: name_index,
              partsList: item.parts,
              disabled: false,
            }
            instList.push(query)
          }
        })
        
        this.instrumentList = instList
        if (this.list.length === 0) {
          this.parentAdd()
        }

        if (res.instruments.length > 0) {
          let list = res.instruments.map((item) => {
            this.instrumentList.forEach((val) => {
              if (val.id === item.instrument_id) {
                item.partList = val.partsList
              }
            })
            if (this.activeName === 'intact') {
              item.unqualified_type = item.parts.length > 0 ? item.parts[0].unqualified_type : ''
              item.unqualified_type_text = item.parts.length > 0 ? item.parts[0].unqualified_type_text : ''
            }
            for(let i=0;i<item.parts.length;i++){
              if(item.parts[i].unqualified_type_remark){
                item.parts[i].unqualified_type_remarkBF = item.parts[i].unqualified_type_remark
              }else{
                item.parts[i].unqualified_type_remark = ''
              }
            }
            return item
          })
          this.list = list
          this.$set(this.queryForm, 'check_type', res.instruments[0].check_type)
        }
      })
    },
    async getDict() {
      return await this.$utils.getDict([474, 481, 502, 503, 504, 505, 506, 561, 562]).then((res) => {
        this.monitorTypeList = res[502]
        this.schedulingList = res[505]
        this.workTimeList = res[506]
        this.examineList = res[481]
        this.examineList.forEach((item) => {
          if (item.is_default === 1) {
            this.queryForm.check_type = item.value
            this.queryForm.check_type_text = item.name
          }
        })

        this.qualityPartList = res[474]
        this.qualityPartList.forEach((item) => {
          if (item.is_default === 1) {
            this.queryForm.quality_part = item.value
            this.queryForm.quality_part_text = item.name
          }
        })
        this.cleanUnQualified = res[503]
        this.cleanHandleType = res[504]
        this.intactUnQualified = res[561]
        this.intactHandleType = res[562]
      })
    },
    getUserList() {
      const url = userOptions.replace('{type}', 2)
      this.$request('get', url).then((res) => {
        this.registerUserList = res
        // 登记人赋值当前登录人
        if (this.status === 0) {
          if (this.exec[388] && this.node === 3) {
            this.$set(this.queryForm, 'register_uid', this.row.prepareUser.id)
          } else {
            this.$set(this.queryForm, 'register_uid', this.user.id)
          }
        }
      })
    },
    getInstrumentNameChange(id) {
      this.instrumentsetList.forEach((item) => {
        if (id === item.table_id) {
          this.queryForm.instrumentset_id = item.instrumentset_id
          this.queryForm.instrumentset_name = item.name
        }
      })
      this.getDetails()
    },
    handleClick() {
      if (this.activeName === 'intact') {
        this.unqualifiedTypeList = this.intactUnQualified
        this.handleTypeList = this.intactHandleType
      } else {
        this.unqualifiedTypeList = this.cleanUnQualified
        this.handleTypeList = this.cleanHandleType
      }
      this.status!==3&&this.getDetails()   //补登记的时候不需要
    },
    childAdd(row) {
      row.push({
        monitor_type: this.monitorTypeList[0].value,
        monitor_type_text: this.monitorTypeList[0].name,
        unqualified_type: this.unqualifiedTypeList[0].value,
        unqualified_type_text: this.unqualifiedTypeList[0].name,
        instrument_part_type_id: '',
        unqualified_type_remark:'',
        files: [],
      })
    },
    childDelete(index, row) {
      if (row.length > 1) {
        row.splice(index, 1)
      }
    },
    parentAdd() {
      // 列表中添加一行
      const query = {
        instrument_id: '',
        instrument_name: '',
        instrument_index: '',
        instrument_abc_code: '',
        instrument_part_type_id: '',
        instrument_part_type_text: '',
        handle_type: this.handleTypeList[0].value,
        handle_type_text: this.handleTypeList[0].name,
        once: 0, // 器械下部位附默认值整体只触发一次
        unqualified_type: this.unqualifiedTypeList[0].value,
        unqualified_type_text: this.unqualifiedTypeList[0].name,
        parts: [{
          monitor_type: this.monitorTypeList[0].value,
          monitor_type_text: this.monitorTypeList[0].name,
          unqualified_type: this.unqualifiedTypeList[0].value,
          unqualified_type_text: this.unqualifiedTypeList[0].name,
          instrument_part_type_id: '',
          unqualified_type_remark:''
        }],
        files: [],
      }
      this.list.push(query)
    },
    parentDelete(index) {
      if (this.list.length > 1) {
        this.list.splice(index, 1)
        this.instrumentListDisable()
      }
    },
    submit() {
      this.$refs.queryForm.validate((valid) => {
        if (valid) {
          const instruments = this.list.map((item) => {
            const query = {
              check_type: this.queryForm.check_type,
              check_type_text: this.queryForm.check_type_text,
              instrument_id: item.instrument_id,
              instrument_name: item.instrument_name,
              instrument_index: item.instrument_index,
              instrument_abc_code: item.instrument_abc_code,
              instrument_part_type_id: item.instrument_part_type_id ? item.instrument_part_type_id : 0,
              instrument_part_type_text: item.instrument_part_type_text ? item.instrument_part_type_text : '',
              handle_type: item.handle_type,
              handle_type_text: item.handle_type_text,
              else_remark: item.handle_type === 4 ? item.else_remark : '',
              remark: item.remark,
              parts: this.activeName === 'clean'? item.parts : [{instrument_part_type_id: 0, instrument_part_type_text: `整体`, unqualified_type: item.unqualified_type, unqualified_type_text: item.unqualified_type_text}],
              file_id:item.files.map(v => v.id)
            }
            return query
          })
          const {table_id, happen_time, code, instrumentset_id, instrumentset_name, clean_uid, first_check_uid, recheck_uid, register_uid, quality_part, quality_part_text, scheduling, scheduling_text, work_time, work_time_text,group_leader_uid, nurse_uid, quality_uid, checkout_uid, quality_part_department_id, pre_handle_uid} = this.queryForm
          const query = {
            type: 7,
            register_type: this.activeName === 'clean' ? 0 : 1,
            node: this.node,
            table_id: table_id,
            basic: {
              happen_time,
              code,
              instrumentset_id,
              instrumentset_name,
              clean_uid,
              first_check_uid,
              recheck_uid,
              register_uid,
              quality_part,
              quality_part_text,
              scheduling,
              scheduling_text,
              work_time,
              work_time_text,
              group_leader_uid,
              nurse_uid,
              quality_uid,
              checkout_uid,
              quality_part_department_id,
              pre_handle_uid,
            },
            instruments: instruments
          }
          this.$request('post', qualityIssuesRegister, query).then((res) => {
            if (res) {
              this.$emit('finishRegister')
              this.cancel() 
              if (this.status==3) {
                this.$parent.sourch()
              }
            }
          })

        } else {
          return false
        }
      })
    },
    cancel() {
      this.show = false
      this.queryForm.code = ''
      this.queryForm = {
        check_type: undefined,
        check_type_text: undefined,
        first_check_uid: undefined,
        scheduling: undefined,
        work_time: undefined,
        register_uid: undefined,
        group_leader_uid: undefined,
        nurse_uid: undefined,
        quality_uid: undefined,
        quality_part: undefined,
        checkout_uid: undefined,
        recheck_uid: undefined,
        happen_time: undefined,
        quality_part_department_id: undefined
      }
      this.status==3&&(this.queryForm.happen_time='')
      this.$refs.queryForm.resetFields()
      this.list = []
    },
    checkTypeChange(id) {
      this.examineList.forEach((item) => {
        if (id === item.value) {
          this.queryForm.check_type_text = item.name
        }
      })
    },
    // 表格中器械名称change事件
    instrumentTableChange(row) {
      this.instrumentList.forEach((item) => {
        if (row.instrument_index === item.instrument_index) {
          row.instrument_id = item.id
          row.instrument_name = item.name
          row.instrument_abc_code = item.abc_code
          row.instrument_part_type_id = item.instrument_part_type_id
          row.instrument_part_type_text = item.instrument_part_type_text
          this.$set(row, 'partList', item.partsList)
          this.$set(row, 'parts', row.parts.concat([]))
          if (row.once === 0) {
            row.once += 1
            row.parts[0].instrument_part_type_id = 0
            row.parts[0].instrument_part_type_text = `整体`
            row.partList[0].disabled = true
          }
        }
      })
      this.instrumentListDisable()
    },
    // 器械不可重复选则
    instrumentListDisable() {
      const instrument = this.list.map(i => {return i.instrument_index})
      this.instrumentList.forEach((item) => {
        if (instrument.includes(item.instrument_index)) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      })
    },
    qualityPartChange(id) {
      this.qualityPartList.forEach((item) => {
        if (id === item.value) {
          this.queryForm.quality_part_text = item.name
        }
      })
    },
    schedulingChange(id) {
      this.schedulingList.forEach((item) => {
        if (item.value === id) {
          this.queryForm.scheduling_text = item.name
        }
      })
    },
    workTimeChange(id) {
      this.workTimeList.forEach((item) => {
        if (item.value === id) {
          this.queryForm.work_time_text = item.name
        }
      })
    },
    handleTypeChange(row) {
      this.handleTypeList.forEach((item) => {
        if(row.handle_type === item.value) {
          row.handle_type_text = item.name
        }
      })
    },
    partsChange(row, fRows) {
      fRows.partList.forEach((item) => {
        if (row.instrument_part_type_id === item.id) {
          row.instrument_part_type_text = item.name
        }
      })

      // 处理部位下拉中整体如果被选中则不能再选
      let not = false
      fRows.parts.forEach((item) => {
        if (item.instrument_part_type_id === 0) {
          not = true
        }
      })

      if (not) {
        fRows.partList[0].disabled = true
      } else {
        fRows.partList[0].disabled = false
      }
    },
    monitorTypeChange(row) {
      this.monitorTypeList.forEach((item) => {
        if (row.monitor_type === item.value) {
          row.monitor_type_text = item.name
        }
      })
    },
    unqualifiedTypeChange(row,pindex,sindex) {
      if( pindex && sindex && row.unqualified_type==5){ //当不合格类型不是“其他”的时候要把描述的内容清空，如果是“其他”，那就要把描述的值赋值给输入框
        this.list[pindex].parts[sindex].unqualified_type_remark = this.list[pindex].parts[sindex].unqualified_type_remarkBF
      }else{
        this.list[pindex].parts[sindex].unqualified_type_remark = ''
      }
      this.unqualifiedTypeList.forEach((item) => {
        if (row.unqualified_type === item.value) {
          row.unqualified_type_text = item.name
        }
      })
    },
    async checkCodeAndAdd(code) {
      const { id } = await this.$utils.getCode(code)

      if ((id === 25 || id === 27)) {
        this.queryForm.code = code
        //获取包详情
        this.getDetails()
      } else if (id === 19) {
        this.getCodeUser(code)
      } else {
        return this.$message.error(`请扫描正确的码`)
      }
    },
    getCodeUser(code) {
      const param = {
        code
      }
      this.$request('get', scanCheckUser, param )
      .then((res) => {
        this.queryForm.register_uid = res.id
      })
    },
    takePicture(row){
      this.$refs.pictureSelect.show()
      this.activeRow = row
    },
    //拍照完成的回调
    onFinishShot(pictures){
       // 获取图片
      const list = pictures.map((i) => {
        return { id: i.fileId, url: i.fileUrl }
      })
      const images = (this.activeRow.files || []).concat(list)
      this.$set(this.activeRow, 'files', images)
    },
    delImg(item, index) {
      if (this.status === 1) return
      item.files.splice(index, 1)
    },
      //处理包码手动输入
    async onEnter(){
          if(!this.queryForm.code) return    //没有输入包码不处理
          this.lastCode = this.queryForm.code   
          const { id } = await this.$utils.getCode(this.queryForm.code)
                      if ((id === 25 || id === 27)) {
                        //获取包详情
                        this.getDetails()
                      } else {
                         this.queryForm.code=''
                        return this.$message.error(`请输入正确的包码`)
                      }
    },
    remoteRecheckMethod(code) {
      const url = userOptions.replace('{type}', 2)
      if (code) {
        this.$request('get', scanCheckUser, {code}).then((res) => {
          if (res) {
            this.queryForm.recheck_uid = res.id
          }
        })
      } else {
        this.$request('get', url).then((res) => {
          this.recheckList = res
        })
      }
    },
    getDepartment(name) {
      const query = {
        name,
      }
      this.$request('get', departmentOptions, query).then((res) => {
        this.dempartmentOptions = res
      })
    },
    preHandleUidMethod(name) {
      const url = userOptions.replace('{type}', 0)
      this.$request('get', url, {name, department_ids: [this.user.department_center.id]}).then((res) => {
        this.preHandleUidList = res
      })
    },
  }
}
</script>
